import React, { Component } from "react";
import styled from "styled-components";
import { Grid, Row, Col } from 'react-flexbox-grid';

const Wrapper = styled.header`
  background: #fff;
  padding-left: 15px;
  padding-top: 5px;
  padding-bottom: 40px;

  * {
    text-align: left;
  }

  h1 {
    color: #333;
    font-size: 1.625em;
    font-weight: 700;
  }

  pre {
    background: #f4f4f4;
    border: 1px solid #ddd;
    border-left: 3px solid #f36d33;
    color: #666;
    page-break-inside: avoid;
    font-family: monospace;
    font-size: 15px;
    line-height: 1.6;
    margin-bottom: 1.6em;
    max-width: 100%;
    overflow: auto;
    padding: 1em 1.5em;
    display: block;
    word-wrap: break-word;
  }
`;

class PrivacyPolicy extends Component {
  render() {
    return (
      <Wrapper>
        <Grid fluid>
          <Row>
            <Col xs={12}>
              <h1>Blockscale Privacy Policy</h1>

              <p>
                This privacy policy has been compiled to better serve those who are concerned with how their
                "Personally Identifiable Information" (PII) is being used online. PII, as described in US
                privacy law and information security, is information that can be used on its own or with other
                information to identify, contact, or locate a single person, or to identify an individual in context.
                Please read our privacy policy carefully to get a clear understanding of how we collect, use, protect
                or otherwise handle your Personally Identifiable Information in accordance with our website.
              </p>

              <h3>What personal information do we collect from the people who visit our blog, website or app?</h3>

              <p>
                When ordering or registering on our site, as appropriate, you may be asked to enter your name, email
                address, mailing address or other details to help you with your experience.
              </p>

              <p>When using our website, applications, and services, we collect your IP address.</p>

              <h3>When do we collect information?</h3>

              <p>
                We collect information from you when you register on our site, place an order, Open a Support Ticket,
                enter information on our site, or use one of our applications or services.
              </p>

              <h3>How do we use your information?</h3>

              <p>
                We may use the information we collect from you when you register, make a purchase, sign up for our
                newsletter, respond to a survey or marketing communication, surf the website, use our applications and
                services, or use certain other site features in the following ways:
              </p>

              <ul>
                <li>To personalize your experience and to allow us to deliver the type of content and product offerings
                  in which you are most interested.
                </li>
                <li>To improve our website in order to better serve you.</li>
                <li>To allow us to better service you in responding to your customer service requests.</li>
                <li>To quickly process your transactions.</li>
                <li>To follow up with them after correspondence (live chat, email or phone inquiries)</li>
                <li>To protect our applications and services from attacks and other security-related events.</li>
              </ul>

              <h3>How do we protect your information?</h3>

              <p>
                We use industry standard best practice vulnerability scanning technology to keep our systems secure,
                and patch all vulnerabilities within a reasonable timeframe.
              </p>
              <p>An external PCI compliant payment gateway handles all CC transactions.</p>
              <p>
                Your personal information is contained behind secured networks and is only accessible by a limited
                number of persons who have special access rights to such systems, and are required to keep the
                information confidential. In addition, all sensitive/credit information you supply is encrypted via
                Transport Layer Security (TLS) technology.
              </p>

              <p>
                We implement a variety of security measures when a user places an order, enters, submits, or accesses
                their information, to maintain the safety of your personal information.
              </p>
              <p>
                All transactions are processed through a gateway provider and are not stored or processed on our
                servers.
              </p>

              <h3>Do we use cookies?</h3>

              <p>
                Yes. Cookies are small files that a site or its service provider transfers to your computer's hard
                drive through your Web browser (if you allow) that enables the site's or service provider's
                systems to recognize your browser and capture and remember certain information. For instance, we use
                cookies to help us remember and process the items in your shopping cart. They are also used to help us
                understand your preferences based on previous or current site activity, which enables us to provide you
                with improved services. We also use cookies to help us compile aggregate data about site traffic and
                site interaction so that we can offer better site experiences and tools in the future.
              </p>

              <p>We use cookies to understand and save users' preferences for future visits.</p>

              <p>
                You can choose to have your computer warn you each time a cookie is being sent, or you can choose to
                turn off all cookies. You do this through your browser settings. Since browser is a little different,
                look at your browser's Help Menu to learn the correct way to modify your cookies.
              </p>

              <h3>If users disable cookies in their browser:</h3>

              <p>
                If you turn cookies off, Some of the features that make your site experience more efficient may not
                function properly.Some of the features that make your site experience more efficient and may not
                function properly.
              </p>

              <h3>Third-party disclosure</h3>

              <p>
                We do not sell, trade, or otherwise transfer to outside parties your Personally Identifiable Information
                unless we provide users with advance notice. This does not include website hosting partners and other
                parties who assist us in operating our website, conducting our business, or serving our users, so long
                as those parties agree to keep this information confidential. We may also release information when it's
                release is appropriate to comply with the law, enforce our site policies, or protect ours or others'
                rights, property or safety.
              </p>

              <p>
                However, non-personally identifiable visitor information may be provided to other parties for marketing,
                advertising, or other uses.
              </p>

              <h3>Third-party links</h3>

              <p>We do not include or offer third-party products or services on our website.</p>

              <p>
                We use first-party cookies (such as the Google Analytics cookies) to track usage of our website in order
                to improve the user experience.
              </p>

              <h3>California Online Privacy Protection Act</h3>

              <p>
                <a
                  href="https://consumercal.org/about-cfc/cfc-education-foundation/california-online-privacy-protection-act-caloppa-3/">CalOPPA</a>
                &nbsp;is the first state law in the nation to require commercial websites and online services to post
                a privacy policy. The law's reach stretches well beyond California to require any person or company in
                the United States (and conceivably the world) that operates websites collecting Personally Identifiable
                Information from California consumers to post a conspicuous privacy policy on its website stating
                exactly the information being collected and those individuals or companies with whom it is being shared.
              </p>

              <p>According to CalOPPA, we agree to the following:</p>

              <ul>
                <li>Users can visit our site anonymously.</li>
                <li>
                  Once this privacy policy is created, we will add a link to it on our home page or as a minimum, on
                  the first significant page after entering our website.
                </li>
                <li>
                  Our Privacy Policy link includes the word 'Privacy' and can easily be found on the page specified
                  above.
                </li>
              </ul>

              <p>You will be notified of any Privacy Policy changes on our Privacy Policy Page.</p>

              <p>You can change your personal information:</p>
              <ul>
                <li>By emailing us</li>
                <li>By logging in to your account and editing your user profile</li>
              </ul>

              <h3>How does our site handle Do Not Track signals?</h3>
              <p>
                We honor Do Not Track signals and Do Not Track, plant cookies, or use advertising when a Do Not Track
                (DNT) browser mechanism is in place.
              </p>

              <h3>Does our site allow third-party behavioral tracking?</h3>

              <p>It's also important to note that we do not allow third-party behavioral tracking</p>

              <h3>COPPA (Children Online Privacy Protection Act)</h3>

              <p>
                When it comes to the collection of personal information from children under the age of 13 years old, the
                Children's Online Privacy Protection Act (COPPA) puts parents in control. The Federal Trade Commission,
                United States' consumer protection agency, enforces the COPPA Rule, which spells out what operators of
                websites and online services must do to protect children's privacy and safety online.
              </p>

              <p>We do not specifically market to children under the age of 13 years old.</p>

              <h3>Fair Information Practices</h3>

              <p>
                The Fair Information Practices Principles form the backbone of privacy law in the United States and the
                concepts they include have played a significant role in the development of data protection laws around
                the globe. Understanding the Fair Information Practice Principles and how they should be implemented is
                critical to comply with the various privacy laws that protect personal information.
              </p>

              <p>
                In order to be in line with Fair Information Practices we will take the following responsive action,
                should a data breach occur:
              </p>

              <ul>
                <li>We will notify you via email within 7 business days</li>
                <li>We will notify the users via in-site notification within 7 business days</li>
              </ul>

              <p>
                We also agree to the Individual Redress Principle which requires that individuals have the right to
                legally pursue enforceable rights against data collectors and processors who fail to adhere to the law.
                This principle requires not only that individuals have enforceable rights against data users, but also
                that individuals have recourse to courts or government agencies to investigate and/or prosecute
                non-compliance by data processors.
              </p>

              <h3>CAN SPAM Act</h3>

              <p>
                The CAN-SPAM Act is a law that sets the rules for commercial email, establishes requirements for
                commercial messages, gives recipients the right to have emails stopped from being sent to them, and
                spells out tough penalties for violations.
              </p>

              <h3>We collect your email address in order to:</h3>

              <ul>
                <li>Send information, respond to inquiries, and/or other requests or questions</li>
                <li>Process orders and to send information and updates pertaining to orders.</li>
                <li>Send you additional information related to your product and/or service</li>
                <li>
                  Market to our mailing list or continue to send emails to our clients after the original transaction
                  has occurred.
                </li>
              </ul>

              <h3>To be in accordance with CANSPAM, we agree to the following:</h3>
              <ul>
                <li>Not use false or misleading subjects or email addresses.</li>
                <li>Identify the message as an advertisement in some reasonable way.</li>
                <li>Include the physical address of our business or site headquarters.</li>
                <li>Monitor third-party email marketing services for compliance, if one is used.</li>
                <li>Honor opt-out/unsubscribe requests quickly.</li>
                <li>Allow users to unsubscribe by using the link at the bottom of each email.</li>
              </ul>

              <p>
                If at any time you would like to unsubscribe from receiving future emails, you can follow the
                instructions at the bottom of each email and we will promptly remove you from all correspondence.
              </p>

              <h3>Contacting Us</h3>

              <p>
                If there are any questions regarding this privacy policy, you may contact us using the information
                below.
              </p>

              <pre><code>
                Blockscale LLC<br />
                contact@blockscale.net
              </code></pre>

              <p>Last Edited on 27 Feb 2019</p>
            </Col>
          </Row>
        </Grid>
      </Wrapper>
    );
  }
}

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./src/App/PrivacyPolicy/index.js